import Immutable from "immutable";

export const hasValue = x => x !== null && x !== undefined;

export const firstWithValue = (...xs) => Immutable.List(xs).find(hasValue);
